import React, { useEffect, useState } from "react";
import { useGearstudioAuth } from "./providers/GearstudioAuthProvider";
import { MessageDisplay, useMessage } from "@shared_components/providers/MessageProvider";
import { HandleAxiosPromise } from "@shared_components/axios/HandleAxiosPromise";
import { FETCH_GEARSTUDIO_TEMPLATES_URL, GearstudioProduct } from "./types";
import { GearStudioBody } from "./views/gearstudiobody";
import { GearstudioNavbar } from "./components/gearstudionavbar";
import { Navigate, Route, Routes } from "react-router-dom";
import { EditDesignView } from "./views/EditDesignView";
import { GearstudioFaqView } from "./views/gearstudiofaq";

const GearstudioView = () => {
  const { loading, loggedIn, user } = useGearstudioAuth();
  const [templates, setTemplates] = useState<GearstudioProduct[]>([]);
  const [loadingTemplates, setLoadingTemplates] = useState(true);
  const [showHistory, setShowHistory] = useState(false);

  const { setTextData } = useMessage();

  const fetchTemplates = () => {
    HandleAxiosPromise({
      url: FETCH_GEARSTUDIO_TEMPLATES_URL,
      method: "get",
      timeout: 10000,
      additional_headers: { "User-Id": user?.id || "" },
    })
      .then((response: any) => {
        if (response && response?.status === 200 && Array.isArray(response.data)) {
          setTemplates(response.data);
          setLoadingTemplates(false);

        } else {
          setTemplates([]);
          setTextData({ text: "No templates available right now.", variant: "warning" });
        }
      })
      .catch((error: string) => {
        const message = error || "Failed to fetch templates.";
        setTextData({ text: message, variant: "danger" });
        setTemplates([]);
      })

  };

  useEffect(() => {
    if (!user || !loggedIn) {
      setTemplates([]);
      setLoadingTemplates(false);
      return;
    }
    fetchTemplates();
  }, [loggedIn, user?.id]);


  if (loading) {
    return (
      <main className="gearstudio-page px-6 py-12">
        <div className="gs-surface mx-auto max-w-md p-8">
          <p className="gs-secondary text-sm">Checking session...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="gearstudio-page">
      {loggedIn ? (
          <GearstudioNavbar showHistory={showHistory} setShowHistory={setShowHistory} />
        ) : null}

      <div className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6">
        <Routes>
          <Route
            path="/"
            element={(
              <GearStudioBody
                templates={templates}
                loadingTemplates={loadingTemplates}
                loggedIn={loggedIn}
                user_uuid={user?.id || ""}
                user_email={user?.email || ""}
                showHistory={showHistory}
                setShowHistory={setShowHistory}
              />
            )}
          />
          <Route
            path="/designs/:designId/edit/"
            element={(
              <EditDesignView
                loggedIn={loggedIn}
                user_uuid={user?.id || ""}
              />
            )}
          />
          <Route path="/faq" element={<GearstudioFaqView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <MessageDisplay />
    </main>
  );
};

export default GearstudioView;
